module.exports = __webpack_public_path__ + "img/application.fad03ffa.jpg";